<template>
  <div style>
    <div class="site-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 single-content">
            <p class="mb-5">
              <img src="../assets/images/big_img_1.jpg" alt="Image" class="img-fluid" />
            </p>
            <h1 class="mb-4">{{ content.title }}</h1>
            <div class="post-meta d-flex mb-5">
              <div class="bio-pic mr-3">
                <img src="../assets/images/person_1.jpg" alt="Image" class="img-fluidid" />
              </div>
              <div class="vcard">
                <span class="d-block">
                  <a href="#">Dave Rogers</a> in
                  <a href="#">News</a>
                </span>
                <span class="date-read">
                  Jun 14
                  <span class="mx-1">&bullet;</span> 3 min read
                  <span class="icon-star2"></span>
                </span>
              </div>
            </div>

            <div v-html="content.body"></div>
            
            <div class="pt-5">
              <p>
                Categories:
                <a href="#">Design</a>,
                <a href="#">Events</a> Tags:
                <a href="#">#html</a>,
                <a href="#">#trends</a>
              </p>
            </div>

            <div class="pt-5">
              <div class="section-title">
                <h2 class="mb-5">6 Comments</h2>
              </div>
              <!-- <ul class="comment-list">
                <li class="comment">
                  <div class="vcard bio">
                    <img src="images/person_1.jpg" alt="Image placeholder" />
                  </div>
                  <div class="comment-body">
                    <h3>Jean Doe</h3>
                    <div class="meta">January 9, 2018 at 2:21pm</div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur quidem laborum necessitatibus, ipsam impedit vitae autem, eum officia, fugiat saepe enim sapiente iste iure! Quam voluptas earum impedit necessitatibus, nihil?</p>
                    <p>
                      <a href="#" class="reply">Reply</a>
                    </p>
                  </div>
                </li>

                <li class="comment">
                  <div class="vcard bio">
                    <img src="../assets/images/person_1.jpg" alt="Image placeholder" />
                  </div>
                  <div class="comment-body">
                    <h3>Jean Doe</h3>
                    <div class="meta">January 9, 2018 at 2:21pm</div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur quidem laborum necessitatibus, ipsam impedit vitae autem, eum officia, fugiat saepe enim sapiente iste iure! Quam voluptas earum impedit necessitatibus, nihil?</p>
                    <p>
                      <a href="#" class="reply">Reply</a>
                    </p>
                  </div>

                  <ul class="children">
                    <li class="comment">
                      <div class="vcard bio">
                        <img src="../assets/images/person_1.jpg" alt="Image placeholder" />
                      </div>
                      <div class="comment-body">
                        <h3>Jean Doe</h3>
                        <div class="meta">January 9, 2018 at 2:21pm</div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur quidem laborum necessitatibus, ipsam impedit vitae autem, eum officia, fugiat saepe enim sapiente iste iure! Quam voluptas earum impedit necessitatibus, nihil?</p>
                        <p>
                          <a href="#" class="reply">Reply</a>
                        </p>
                      </div>

                      <ul class="children">
                        <li class="comment">
                          <div class="vcard bio">
                            <img src="../assets/images/person_1.jpg" alt="Image placeholder" />
                          </div>
                          <div class="comment-body">
                            <h3>Jean Doe</h3>
                            <div class="meta">January 9, 2018 at 2:21pm</div>
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur quidem laborum necessitatibus, ipsam impedit vitae autem, eum officia, fugiat saepe enim sapiente iste iure! Quam voluptas earum impedit necessitatibus, nihil?</p>
                            <p>
                              <a href="#" class="reply">Reply</a>
                            </p>
                          </div>

                          <ul class="children">
                            <li class="comment">
                              <div class="vcard bio">
                                <img src="../assets/images/person_1.jpg" alt="Image placeholder" />
                              </div>
                              <div class="comment-body">
                                <h3>Jean Doe</h3>
                                <div class="meta">January 9, 2018 at 2:21pm</div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur quidem laborum necessitatibus, ipsam impedit vitae autem, eum officia, fugiat saepe enim sapiente iste iure! Quam voluptas earum impedit necessitatibus, nihil?</p>
                                <p>
                                  <a href="#" class="reply">Reply</a>
                                </p>
                              </div>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>

                <li class="comment">
                  <div class="vcard bio">
                    <img src="../assets/images/person_1.jpg" alt="Image placeholder" />
                  </div>
                  <div class="comment-body">
                    <h3>Jean Doe</h3>
                    <div class="meta">January 9, 2018 at 2:21pm</div>
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Pariatur quidem laborum necessitatibus, ipsam impedit vitae autem, eum officia, fugiat saepe enim sapiente iste iure! Quam voluptas earum impedit necessitatibus, nihil?</p>
                    <p>
                      <a href="#" class="reply">Reply</a>
                    </p>
                  </div>
                </li>
              </ul> -->
              <!-- END comment-list -->

              <!-- <div class="comment-form-wrap pt-5">
                <div class="section-title">
                  <h2 class="mb-5">Leave a comment</h2>
                </div>
                <form action="#" class="p-5 bg-light">
                  <div class="form-group">
                    <label for="name">Name *</label>
                    <input type="text" class="form-control" id="name" />
                  </div>
                  <div class="form-group">
                    <label for="email">Email *</label>
                    <input type="email" class="form-control" id="email" />
                  </div>
                  <div class="form-group">
                    <label for="website">Website</label>
                    <input type="url" class="form-control" id="website" />
                  </div>

                  <div class="form-group">
                    <label for="message">Message</label>
                    <textarea name id="message" cols="30" rows="10" class="form-control"></textarea>
                  </div>
                  <div class="form-group">
                    <input type="submit" value="Post Comment" class="btn btn-primary py-3" />
                  </div>
                </form>
              </div> -->
            </div>
          </div>

          <div class="col-lg-3 ml-auto">
            <div class="section-title">
              <h2>Popular Posts</h2>
            </div>

            <div class="trend-entry d-flex">
              <div class="number align-self-start">01</div>
              <div class="trend-contents">
                <h2>
                  <a href="blog-single.html">News Needs to Meet Its Audiences Where They Are</a>
                </h2>
                <div class="post-meta">
                  <span class="d-block">
                    <a href="#">Dave Rogers</a> in
                    <a href="#">News</a>
                  </span>
                  <span class="date-read">
                    Jun 14
                    <span class="mx-1">&bullet;</span> 3 min read
                    <span class="icon-star2"></span>
                  </span>
                </div>
              </div>
            </div>

            <div class="trend-entry d-flex">
              <div class="number align-self-start">02</div>
              <div class="trend-contents">
                <h2>
                  <a href="blog-single.html">News Needs to Meet Its Audiences Where They Are</a>
                </h2>
                <div class="post-meta">
                  <span class="d-block">
                    <a href="#">Dave Rogers</a> in
                    <a href="#">News</a>
                  </span>
                  <span class="date-read">
                    Jun 14
                    <span class="mx-1">&bullet;</span> 3 min read
                    <span class="icon-star2"></span>
                  </span>
                </div>
              </div>
            </div>

            <div class="trend-entry d-flex">
              <div class="number align-self-start">03</div>
              <div class="trend-contents">
                <h2>
                  <a href="blog-single.html">News Needs to Meet Its Audiences Where They Are</a>
                </h2>
                <div class="post-meta">
                  <span class="d-block">
                    <a href="#">Dave Rogers</a> in
                    <a href="#">News</a>
                  </span>
                  <span class="date-read">
                    Jun 14
                    <span class="mx-1">&bullet;</span> 3 min read
                    <span class="icon-star2"></span>
                  </span>
                </div>
              </div>
            </div>

            <div class="trend-entry d-flex pl-0">
              <div class="number align-self-start">04</div>
              <div class="trend-contents">
                <h2>
                  <a href="blog-single.html">News Needs to Meet Its Audiences Where They Are</a>
                </h2>
                <div class="post-meta">
                  <span class="d-block">
                    <a href="#">Dave Rogers</a> in
                    <a href="#">News</a>
                  </span>
                  <span class="date-read">
                    Jun 14
                    <span class="mx-1">&bullet;</span> 3 min read
                    <span class="icon-star2"></span>
                  </span>
                </div>
              </div>
            </div>

            <p>
              <a href="#" class="more">
                See All Popular
                <span class="icon-keyboard_arrow_right"></span>
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Parse from 'parse'

export default {
  data() {
    return {
      content: undefined
    }
  },
  props: ["slug", "id"],
  mounted() {
    console.log("slug ", this.slug);
    console.log("id ", this.id);
    this.retrieveSinglePost()
  },
  methods: {
    retrieveSinglePost() {
      const Posts = Parse.Object.extend('Posts');
      let q = new Parse.Query(Posts)

      q.get(this.id).then((obj) => {
        let o = JSON.stringify(obj)
        this.content = JSON.parse(o);
        console.log('news :: ', this.content);
      }, (err) => {
        console.log(err)
      })
    },
    chooseBlog(blog) {
      console.log('blog', blog)
      this.$router.push({ path: 'view', query: { slug: 'private', id: 'test' } })
    }
  }
};
</script>